export const billingFrequency = {
  monthly: 'Mensal',
  yearly: 'Anual'
};
